import { render, staticRenderFns } from "./PartnersListView.vue?vue&type=template&id=844eade2&"
import script from "./PartnersListView.vue?vue&type=script&lang=js&"
export * from "./PartnersListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports